<dx-data-grid #dataGridArticoliMatricola [dataSource]="dataSource" [dataSource]="dataSource" [showBorders]="true"
  [focusedRowEnabled]="false" [focusedRowIndex]="0" [allowColumnResizing]="true" [columnAutoWidth]="true"
  [columnResizingMode]="columnResizingMode" [showColumnLines]="true" [showRowLines]="true"
  [rowAlternationEnabled]="true" [allowColumnReordering]="true" [wordWrapEnabled]="false"
  (onRowUpdating)="onRowUpdating($event)">

  <dxo-paging [pageSize]="20"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [showInfo]="true" [allowedPageSizes]="[10, 20, 50, 100]"></dxo-pager>
  <dxo-filter-row [visible]="false"></dxo-filter-row>
  <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
  <dxo-export [enabled]="true"></dxo-export>
  <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

  <dxo-editing mode="row" [allowAdding]="false" [allowUpdating]="true" [allowDeleting]="true" [useIcons]="true">
    <dxo-texts confirmDeleteMessage="Sei sicuro di voler eliminare il dettaglio?"></dxo-texts>
  </dxo-editing>

  <dxo-data-grid-selection mode="multiple" showCheckBoxesMode="always"></dxo-data-grid-selection>

  <dxo-data-grid-toolbar>
    <dxi-data-grid-item location="after">
      <dx-button (onClick)="stampaMatricole()" icon="print" text="Stampa Etichette" stylingMode="text">
      </dx-button>
    </dxi-data-grid-item>
  </dxo-data-grid-toolbar>

  <dxi-column type="buttons" [width]="60">
    <dxi-button name="edit"></dxi-button>
    <dxi-button name="delete"></dxi-button>
  </dxi-column>

  <dxi-column dataField="id" [visible]="false" [allowEditing]="false" caption="">
  </dxi-column>
  <dxi-column dataField="idArticolo" [visible]="false" [allowEditing]="false" caption="">
  </dxi-column>

  <dxi-column dataField="matricola" caption="Matricola">
  </dxi-column>

  <dxi-column dataField="dataScadenza" caption="Scadenza" format="dd/MM/yyyy" dataType="date" width="120">
  </dxi-column>

  <dxi-column dataField="dismesso" caption="Dismesso" [allowEditing]="false" dataType="boolean">
  </dxi-column>
  @for (prop of listPropsArtMatricola; track prop) {
  <dxi-column dataField="props.{{prop.nome}}" caption="{{prop.nome}}" [dataType]="getDataType(prop.tipo)"
    [format]="getDataFormat(prop.tipo)">
    @if (prop.tipo == TIPO_PROPRIETA_ARTICOLO_SELMULTI) {
    <dxo-lookup [dataSource]="prop.selMultiplaDati">
    </dxo-lookup>
    }
  </dxi-column>
  }
</dx-data-grid>

@if(popupInfoBarCode){
<dx-popup [width]="600" [height]="250" [showTitle]="true" title="Informazioni Aggiuntive" [dragEnabled]="false"
  [hideOnOutsideClick]="true" [(visible)]="popupInfoBarCode">
  <app-popup-barcode (popupBarcodeEventEmitter)="onPopupBarcodeEventEmitter($event)"></app-popup-barcode>
</dx-popup>
}

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadPanelVisible" [showIndicator]="true"
  [showPane]="true" [shading]="true" [hideOnOutsideClick]="false" message="Stampa delle etichette">
</dx-load-panel>